import { libelle } from './libelles';

/** Produits d'un lot, écrits en clair (« Gasoil, Super »), '—' si aucun camion n'en porte. */
export const produitsDuLot = (lot) => {
  const codes = lot?.products?.length ? lot.products : lot?.product ? [lot.product] : [];
  return codes.length ? codes.map((code) => libelle('fuelProduct', code)).join(', ') : '—';
};
